module.exports = __webpack_public_path__ + "img/git-commit.80402f7a.svg";